<template>
  <div class="plugin-stepper">
    <div class="step-item" :class="{ 'passed': 0 <= step }">
      <div class="step-dot"></div>
      <p>{{ $t('条件設定') }}</p>
    </div>
    <div class="step-line" :class="{ 'passed': 1 <= step }"></div>
    <div class="step-item" :class="{ 'passed': 1 <= step }">
      <div class="step-dot"></div>
      <p>{{ $t('配置設定') }}</p>
    </div>
    <div class="step-line" :class="{ 'passed': 2 <= step }"></div>
    <div class="step-item" :class="{ 'passed': 2 <= step }">
      <div class="step-dot"></div>
      <p>{{ $t('加工プレビュー') }}</p>
    </div>
  </div>
</template>

<script>

export default {
  name: 'PluginStepper',
  props: {
    step: {
      type: Number,
      required: true
    }
  }
};

</script>

<style lang="scss" scoped>

$default-color: #888;
$passed-color: #1BFFC6;

.plugin-stepper {
  pointer-events: none;
  user-select: none;

  position: absolute;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 2rem;

  .step-line {
    width: 160px;
    height: 2.5px;
    background-color: $default-color;

    &.passed {
      background-color: $passed-color;
    }
  }

  .step-item {
    position: relative;
    z-index: 2;
    display: flex;
    flex-direction: column;
    align-items: center;

    .step-dot {
      width: 15px;
      height: 15px;
      background-color: $default-color;
      border-radius: 99em;
    }

    p {
      position: absolute;
      text-align: center;
      width: 120px;
      font-size: 0.9rem;
      font-weight: 900;
      margin-top: 1.25rem;
    }

    &.passed {
      .step-dot {
        background-color: $passed-color;
      }
    }
  }

}

</style>



// WEBPACK FOOTER //
// src/components/plugin/PluginStepper.vue